import { solid } from "@randajan/props";
import { info } from "@randajan/simple-app/info";
import { localeBeam } from "./beams/localeBeam";
import { bifrost } from "./bifrost";
import { globalStatsBeam } from "./beams/globalStatsBeam";
import { userStatsVault } from "./vaults/userStatsVault";
import { legalsBeam } from "./beams/legalBeam";
import { themesBeam } from "./beams/themesBeam";
import { eventsBeam } from "./beams/eventsBeam";
import { meBeam } from "./beams/meBeam";
import { opsBeam } from "./beams/opsBeam";
import { imgsBeam } from "./beams/imgsBeam";
import { page } from "./bases/page";
import { store } from "./bases/store";
import { screen } from "@randajan/jet-react/base/screen";
import jet from "@randajan/jet-react";
import { eventBeam } from "./beams/eventBeam";
import { eventSignBeam } from "./beams/eventSignBeam";
import { oauthBeam } from "./beams/oauthBeam";
import { webReviewsBeam } from "./beams/webReviews";

if (!info.isBuild) {

    solid(window, "_", Object.freeze({
        jet,
        page,
        store,
        screen,
        bifrost,
        oauthBeam,
        localeBeam,
        globalStatsBeam,
        userStatsVault,
        legalsBeam,
        themesBeam,
        eventsBeam,
        meBeam,
        opsBeam,
        imgsBeam,
        eventBeam,
        eventSignBeam,
        webReviewsBeam
    }));

}
